// extracted by mini-css-extract-plugin
module.exports = {"tabs-list":"tabs-list","link":"link","active":"active"};